export const facilityExportColumns = [
	{ label: 'Sr No', key: 'index' },

	{
		label: 'Facility Name',
		render: f => f?.facilityName || '',
	},

	{
		label: 'Category',
		render: f => f?.category || '',
	},

	{
		label: 'Facility Type',
		render: f => f?.facilityType || '',
	},

	{
		label: 'Address',
		render: f => f?.address || '',
	},

	{
		label: 'Contact Name',
		render: f => f?.contactName || '',
	},

	{
		label: 'Contact Mobile',
		render: f => f?.contactMobile || '',
	},

	{
		label: 'Sanstha',
		render: f => f?.sanstha?.name || '',
	},

	{
		label: 'Booking Form',
		render: f => f?.form || '',
	},

	{
		label: 'Terms & Condition',
		render: f => f?.terms || '',
	},

	{
		label: 'Created On',
		render: f => (f?.createdAt ? new Date(f.createdAt).toLocaleDateString() : ''),
	},
]
